import { useCallback } from 'react';
import { useHistory, useLocation } from 'react-router';

import { useBoolean } from '@dreryk/react-common';
import { ModalConfirmButton, usePushBack } from '@dreryk/react-components';

import { visitPaths } from '~libs.desktop.shared.paths';

import { appointmentsTranslationKeys } from '../../../translations';

import { AppointmentUpdateModal } from './shared/AppointmentUpdateModal';
import { AppointmentRestoreActionEventInterceptor } from './interceptors/AppointmentRestoreActionEventInterceptor';

type AppointmentRestoreModalProps = {
   readonly appointmentId: number;
};

export const AppointmentRestoreModal = (props: AppointmentRestoreModalProps): JSX.Element | null => {
   const [{ setFalse: closeModal }, modalOpened] = useBoolean(true);
   const pushBack = usePushBack();
   const location = useLocation();
   const history = useHistory();

   const handleCloseModal = useCallback((): void => {
      const searchParams = new URLSearchParams(location.search);
      searchParams.delete(visitPaths.APPOINTMENT_RESTORE_SEARCH_PARAM);

      history.replace({
         search: searchParams.toString(),
         state: location.state,
      });

      closeModal();
   }, [closeModal, history, location.search, location.state]);

   const handleSuccess = useCallback((): void => {
      pushBack(visitPaths.getAppointmentsListPath());
   }, [pushBack]);

   if (!modalOpened) {
      return null;
   }

   return (
      <AppointmentUpdateModal
         title={appointmentsTranslationKeys.update.modal.title.restore}
         confirmButton={({ handleSubmit }) => (
            <AppointmentRestoreActionEventInterceptor appointmentId={props.appointmentId} handleSubmit={handleSubmit}>
               <ModalConfirmButton
                  label={appointmentsTranslationKeys.update.modal.confirm.restore}
                  onClick={handleSuccess}
               />
            </AppointmentRestoreActionEventInterceptor>
         )}
         appointmentId={props.appointmentId}
         onClose={handleCloseModal}
      />
   );
};
